import React from 'react'
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap'

export default class ContactDetails extends React.Component {

    state = {
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
        postcode: ''
    };

    validate = () => {
        const valid = this.form.checkValidity();
        if (!valid) {
            this.form.reportValidity();
            return null;
        }
        return this.state;
    }

    render() {
        const { email, first_name, last_name, phone, postcode } = this.state;

        return (
                <Card className="contact-details-container">
                    <Card.Title>Contact Details</Card.Title>
                    <Card.Body>       

                            <Form
                                ref={(ref) => { this.form = ref; }}
                            >

                                <Form.Group controlId="formName">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control type="text" value={first_name} onChange={e => this.setState({ first_name: e.target.value })} required="required" tabIndex="1"/>
                                </Form.Group>

                                <Form.Group controlId="formName">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type="text" value={last_name} onChange={e => this.setState({ last_name: e.target.value })} required="required" tabIndex="2"/>
                                </Form.Group>

                                <Form.Group controlId="formEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" value={email} onChange={e => this.setState({ email: e.target.value })} required="required" tabIndex="3"/>
                                </Form.Group>

                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Phone</Form.Label>
                                    <Form.Control type="text" value={phone} onChange={e => this.setState({ phone: e.target.value })} required="required" pattern="[0-9]{10}" maxLength={10} tabIndex="4"/>
                                </Form.Group>

                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Postcode</Form.Label>
                                    <Form.Control type="text" value={postcode} onChange={e => this.setState({ postcode: e.target.value })} required="required" pattern="[0-9]{4}" maxLength={4} tabIndex="5"/>
                                </Form.Group>
                            </Form>

                    </Card.Body> 
                </Card>
        );
    }
};